import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faEllipsisV,
  faBars,
  faBell,
  faSpinner,
  faCoffee,
  faChartBar,
  faDatabase,
  faEye,
  faPlus,
  faPlusSquare,
  faMinus,
  faMinusSquare,
  faEdit,
  faTrash,
  faInfo,
  faTh,
  faThList,
  faClone,
  faAsterisk,
  faFile,
  faGlobe,
  faBuilding,
  faPlane,
  faMapMarker,
  faArchive,
  faMoneyBill,
  faTag,
  faPaperPlane,
  faKey,
  faFilePdf,
  faEnvelope,
  faUser,
  faSort,
  faSortUp,
  faSortDown,
  faArrowUp,
  faArrowDown,
  faArrowRight,
  faArrowLeft,
  faChevronUp,
  faChevronDown,
  faChevronRight,
  faChevronLeft,
  faCircle,
  faCheckCircle,
} from '@fortawesome/free-solid-svg-icons';
import { faWordpressSimple } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// FA
library.add(faEllipsisV);
library.add(faBars);
library.add(faBell);
library.add(faSpinner);
library.add(faCoffee);
library.add(faChartBar);
library.add(faDatabase);
library.add(faEye);
library.add(faPlus);
library.add(faPlusSquare);
library.add(faMinus);
library.add(faMinusSquare);
library.add(faEdit);
library.add(faTrash);
library.add(faInfo);
library.add(faTh);
library.add(faThList);
library.add(faClone);
library.add(faAsterisk);
library.add(faFile);
library.add(faGlobe);
library.add(faBuilding);
library.add(faPlane);
library.add(faMapMarker);
library.add(faArchive);
library.add(faMoneyBill);
library.add(faTag);
library.add(faPaperPlane);
library.add(faKey);
library.add(faFilePdf);
library.add(faEnvelope);
library.add(faUser);
library.add(faSort);
library.add(faSortUp);
library.add(faSortDown);
library.add(faArrowUp);
library.add(faArrowDown);
library.add(faArrowRight);
library.add(faArrowLeft);
library.add(faChevronUp);
library.add(faChevronDown);
library.add(faChevronRight);
library.add(faChevronLeft);
library.add(faCircle);
library.add(faCheckCircle);

// FA: Brands
library.add(faWordpressSimple);

export default FontAwesomeIcon;
